import script from "./TicketReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketReservations.vue?vue&type=script&setup=true&lang=js"

import "./TicketReservations.vue?vue&type=style&index=0&id=c964326e&scoped=true&lang=scss"
script.__scopeId = "data-v-c964326e"

export default script